import { render, staticRenderFns } from "./seckillGroup.vue?vue&type=template&id=175be258&scoped=true&"
import script from "./seckillGroup.ts?vue&type=script&lang=ts&"
export * from "./seckillGroup.ts?vue&type=script&lang=ts&"
import style0 from "./seckillGroup.vue?vue&type=style&index=0&id=175be258&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._dqvcgk3en6wwbxrhlb6nnpgame/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175be258",
  null
  
)

export default component.exports